// Breach Step 5: Response
import React from 'react';
import { Card, CardContent } from '../../../../components/ui/card';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Textarea } from '../../../../components/ui/textarea';
import { CalendarInput } from '../../../../components/ui/calendar-input';
import { FieldError } from '../../../../components/ui/field-error';
import { Checkbox } from '../../../../components/ui/checkbox';
import { CONTAINMENT_MEASURES } from '../constants';
import { cn } from '../../../../lib/utils';

export default function Step5Response({ formData, updateField, contScore, errors = {}, onValidationChange }) {
  return (
    <div className="space-y-6">
      <div><h2 className="text-2xl font-bold">Response</h2><p className="text-muted-foreground mt-1">Document actions taken. Containment measures inversely affect risk score.</p></div>
      <Card><CardContent className="pt-6 space-y-4">
        <div>
          <Label>What actions have been taken? <span className="text-destructive">*</span></Label>
          <Textarea
            data-testid="actions-taken"
            value={formData.actions_taken || ''}
            onChange={e => {
              updateField('actions_taken', e.target.value);
              // Clear error on change if field now has value
              if (onValidationChange && e.target.value.trim()) {
                const newErrors = { ...errors };
                delete newErrors.actions_taken;
                onValidationChange(newErrors);
              }
            }}
            onBlur={() => {
              // Clear error on blur if field has value
              if (onValidationChange && formData.actions_taken?.trim()) {
                const newErrors = { ...errors };
                delete newErrors.actions_taken;
                onValidationChange(newErrors);
              }
            }}
            placeholder="Describe the immediate response..."
            className={cn("mt-1.5", errors.actions_taken && "border-destructive bg-destructive/5")}
            rows={4}
          />
          {errors.actions_taken && <FieldError message={errors.actions_taken} />}
        </div>
        <div>
          <Label className="mb-3 block">Containment Measures <span className="text-xs text-muted-foreground">({formData.containment_measures.length}/11 — containment score: {contScore})</span></Label>
          <div className="space-y-2">
            {CONTAINMENT_MEASURES.map((measure) => (
              <div key={measure} className="flex items-start gap-3 p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors">
                <Checkbox
                  checked={formData.containment_measures.includes(measure)}
                  onCheckedChange={(checked) => {
                    const updated = checked
                      ? [...formData.containment_measures, measure]
                      : formData.containment_measures.filter(m => m !== measure);
                    updateField('containment_measures', updated);
                  }}
                  className="mt-1"
                />
                <div className="flex-1 min-w-0">
                  <label className="text-sm font-medium cursor-pointer">{measure}</label>
                </div>
                {formData.containment_measures.includes(measure) && (
                  <CalendarInput
                    value={formData.containment_measures_dates?.[measure] || ''}
                    onChange={(date) => {
                      const updatedDates = { ...formData.containment_measures_dates };
                      if (date) updatedDates[measure] = date;
                      else delete updatedDates[measure];
                      updateField('containment_measures_dates', updatedDates);
                    }}
                    placeholder="When taken"
                    className="w-32 text-xs"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
          <div>
            <Label>Containment Date</Label>
            <div className="mt-1.5">
              <CalendarInput data-testid="containment-date" value={formData.containment_date || ''} onChange={(date) => updateField('containment_date', date)} placeholder="DD/MM/YYYY" />
            </div>
          </div>
          <div><Label>Incident Owner</Label><Input data-testid="incident-owner" value={formData.incident_owner || ''} onChange={e => updateField('incident_owner', e.target.value)} placeholder="Name" className="mt-1.5" /></div>
        </div>
      </CardContent></Card>
    </div>
  );
}
